import clsx from 'clsx';
import './tab.scss';


export interface TabProps {
    tabNames: string[];
    activeTab: string;
    onClick: (tabName: string, tabIndex: number) => void;
}

const Tab = (props: TabProps) => {
    return (
        <div className="live-tabs">
            {props.tabNames.map((tab, index) => (
                <span 
                    key={index}
                    className={clsx("live-tab", props.activeTab === tab && "active")}
                    onClick={() => props.onClick(tab, index)}
                >
                    {tab}
                </span>
            ))}
        </div>
    )
}



export default Tab;